import { QBooksLogo } from '@approvalmax/ui';
import { Flex, Spacing } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { PopupFooter, PopupTitle } from '..';
import { ConnectCard } from '../ConnectCard/ConnectCard';
import { ConnectToOrganisationContent } from '../ConnectToOrganisationContent/ConnectToOrganisationContent';
import { InviteTeammateSuggestion } from '../InviteTeammateSuggestion/InviteTeammateSuggestion';
import { messages } from './QBooksContent.messages';
import { QBooksContentProps } from './QBooksContent.types';

const QBooksContent: FC<QBooksContentProps> = memo((props) => {
    const { isLoading, onCreateDemo, onConnectToOrganisation, onSkip, onBack, onInviteTeammate, withInviteTeammate } =
        props;

    return (
        <>
            <PopupTitle />

            <Spacing height={20} />

            <Flex container spacing='12'>
                <Flex size={12}>
                    <ConnectCard
                        logo={QBooksLogo}
                        title={messages.createDemo({
                            b: (chunks: any) => <b>{chunks}</b>,
                        })}
                        header={messages.demoHeader}
                        description={messages.demoDescribe}
                        buttonText={messages.createAndConnect}
                        onClick={onCreateDemo}
                        isLoading={isLoading}
                    />
                </Flex>

                <Flex size={12}>
                    <ConnectCard
                        logo={QBooksLogo}
                        title={messages.connectToOrganisation}
                        header={messages.connectToOrgHeader}
                        description={<ConnectToOrganisationContent systemName={messages.systemName} />}
                        withConnectQuickBooksButton
                        onClick={onConnectToOrganisation}
                        isLoading={isLoading}
                    />
                </Flex>
            </Flex>

            {withInviteTeammate ? (
                <>
                    <Spacing height={24} />

                    <InviteTeammateSuggestion onInviteTeammate={onInviteTeammate} />

                    <Spacing height={24} />
                </>
            ) : (
                <Spacing height={32} />
            )}

            <PopupFooter withBackButton onBack={onBack} onSkip={onSkip} isLoading={isLoading} />
        </>
    );
});

export default QBooksContent;
